module.exports = __webpack_public_path__ + "img/zebrawood-swatch.713c7911.png";